<div class="product-sync-page">
  <h1>Product Sync</h1>
  <p class="muted">
    Every vendor sync in one place. Click a vendor to open its sync buttons — syncing or
    cancelling here is the same as on the vendor's own Product Sync tab, and progress
    shows in both.
  </p>

  @if (loading()) {
    <p class="muted">Loading…</p>
  }
  @if (error()) {
    <p class="error">{{ error() }}</p>
  }

  <mat-accordion multi class="vendor-accordion">
    @for (v of vendors(); track v.key) {
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ v.vendorName }}
            <!-- Which markets this vendor lists into, readable without opening the section. -->
            @for (market of v.markets; track market) {
              <span
                class="market-chip"
                [matTooltip]="'Products are listed in the ' + market + ' market'"
                >{{ market }}</span
              >
            }
          </mat-panel-title>
          <mat-panel-description>
            <span class="vendor-summary">
              <span
                matTooltip="{{ v.inStock }} of {{ v.totalProducts }} in stock"
              >{{ v.totalProducts }} product{{ v.totalProducts === 1 ? '' : 's' }}</span>
              <span
                class="muted"
                matTooltip="Oldest last-updated among this vendor's sync collections"
              >
                {{ v.lastUpdated ? ('Updated ' + (v.lastUpdated | date: 'medium')) : 'Never synced' }}
              </span>
              @if (v.activeLock) {
                <span class="sync-status">
                  <mat-icon inline class="spin">sync</mat-icon>
                  {{ v.activeLock.done }}/{{ v.activeLock.total }}
                  @if (v.activeLock.currentTitle) {
                    <span class="muted">— {{ v.activeLock.currentTitle }}</span>
                  }
                  @if (v.activeLock.cancelRequested) {
                    <span class="muted">(cancelling…)</span>
                  }
                </span>
              } @else if (v.kind === 'telegram') {
                {{ v.sourceName }}
              } @else {
                {{ v.buttons }} sync button{{ v.buttons === 1 ? '' : 's' }}
              }
            </span>
            <a
              class="vendor-link"
              [routerLink]="['/vendor_input', v.vendorId]"
              (click)="stopToggle($event)"
            >
              Open vendor <mat-icon inline>open_in_new</mat-icon>
            </a>
          </mat-panel-description>
        </mat-expansion-panel-header>

        @if (v.activeLock) {
          <mat-progress-bar
            class="vendor-progress"
            [mode]="v.activeLock.total ? 'determinate' : 'indeterminate'"
            [value]="progress(v)"
          ></mat-progress-bar>
        }

        <ng-template matExpansionPanelContent>
          @if (v.kind === 'telegram') {
            <fh-telegram-ingest-panel [vendorId]="'' + v.vendorId"></fh-telegram-ingest-panel>
          } @else {
            <fh-vendor-product-sync [vendorId]="'' + v.vendorId"></fh-vendor-product-sync>
          }
        </ng-template>
      </mat-expansion-panel>
    }
  </mat-accordion>

  @if (!loading() && !error() && !vendors().length) {
    <p class="muted">No vendor syncs are set up in this database.</p>
  }
</div>
